import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { V2ShellLayoutStore } from './v2-shell-layout.store';

export type V2NavExpandableSection =
    | 'projetos'
    | 'dashboard'
    | 'notificacoes'
    | 'checkout'
    | 'integracoes'
    | 'avancado'
    | 'management';

export type V2NavActiveSection = V2NavExpandableSection | 'lista-notificacoes';

@Injectable()
export class V2ShellNavService {
    expandedSections: Record<V2NavExpandableSection, boolean> = {
        projetos: false,
        dashboard: false,
        notificacoes: false,
        checkout: false,
        integracoes: false,
        avancado: false,
        management: false,
    };

    constructor(
        private router: Router,
        private navigationService: NavigationService,
        private layoutStore: V2ShellLayoutStore,
    ) {}

    toggleSection(section: V2NavExpandableSection): void {
        this.expandedSections[section] = !this.expandedSections[section];
    }

    expandirMenu(section: 'notificacoes' | 'checkout' | 'integracoes' | 'dashboard' | 'avancado'): void {
        if (this.layoutStore.isDesktop && this.layoutStore.isCollapsed) {
            this.layoutStore.isCollapsed = false;
            this.navigationService.triggerMenuCollapse(false);
        }

        (Object.keys(this.expandedSections) as V2NavExpandableSection[]).forEach((key) => {
            this.expandedSections[key] = key === section;
        });
    }

    isSectionActive(section: V2NavActiveSection): boolean {
        const url = this.router.url || '';
        const baseUrl = url.split('?')[0];

        switch (section) {
            case 'notificacoes':
                return baseUrl.startsWith('/v2/notificacoes/') || baseUrl.startsWith('/vendas/integracao');

            case 'lista-notificacoes':
                return (
                    baseUrl.startsWith('/v2/notificacoes/vendas/integracao') || baseUrl.startsWith('/vendas/integracao')
                );

            case 'checkout':
                return baseUrl.startsWith('/v2/checkout/') || baseUrl.startsWith('/checkout/integracao');

            case 'integracoes':
                if (
                    baseUrl.startsWith('/v2/integrations/vturb/analytics') ||
                    baseUrl.startsWith('/v2/integrations/vturb/segmentation-retention')
                ) {
                    return false;
                }
                return (
                    baseUrl.startsWith('/v2/integracoes/') ||
                    baseUrl.startsWith('/v2/integrations/') ||
                    baseUrl.startsWith('/integracoes/')
                );

            case 'dashboard':
                return (
                    baseUrl.startsWith('/v2/analytics/dashboard-metricas') ||
                    baseUrl.startsWith('/v2/analytics/logs-campanhas') ||
                    baseUrl.startsWith('/v2/analytics/relatorio-campanhas') ||
                    baseUrl.startsWith('/v2/analytics/financial-dashboard') ||
                    baseUrl.startsWith('/v2/integrations/vturb/analytics') ||
                    baseUrl.startsWith('/v2/analytics/forbidden')
                );

            case 'avancado':
                return (
                    baseUrl.startsWith('/v2/fees') ||
                    baseUrl.startsWith('/v2/taxes') ||
                    baseUrl.startsWith('/v2/products') ||
                    baseUrl.startsWith('/v2/url-produtor') ||
                    baseUrl.startsWith('/v2/relatorios') ||
                    baseUrl.startsWith('/v2/dominios') ||
                    baseUrl.startsWith('/v2/gerador-url-campanha/produtor') ||
                    baseUrl.startsWith('/url-produtor') ||
                    baseUrl.startsWith('/relatorios') ||
                    baseUrl.startsWith('/dominios') ||
                    baseUrl.startsWith('/gerador-url-campanha/produtor')
                );

            case 'management':
                return baseUrl.startsWith('/v2/analytics/management-ads/');

            default:
                return false;
        }
    }

    afterNavigate(): void {
        if (this.layoutStore.isMobile) {
            this.layoutStore.closeSidenav();
        }
    }
}
